import { User } from "@common/types/user";
import { getTaskAssigneeDisplayName } from "@components/tasks/task-assignee.lib";
import { AvatarTooltip } from "@components/avatar/AvatarTooltip";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { AvatarGroup } from "@design-system/Avatar/AvatarGroup";

interface ViewerAvatarsProps {
    users: User[];
}

const MAX_VISIBLE_AVATARS = 3;

export const ViewerAvatars = ({ users }: ViewerAvatarsProps) => {
    if (users.length === 0) {
        return null;
    }

    return (
        <AvatarGroup
            items={users}
            getKey={(user) => user.id}
            getLabel={getTaskAssigneeDisplayName}
            renderAvatar={(user) => (
                <AvatarTooltip
                    content={`${getTaskAssigneeDisplayName(user)} viewing`}
                >
                    <UserAvatar user={user} />
                </AvatarTooltip>
            )}
            max={MAX_VISIBLE_AVATARS}
            size="sm"
        />
    );
};
